// extracted by mini-css-extract-plugin
export var stepActive = "_2o-3";
export var stepCompleted = "_2o-4";
export var stepConnectorLine = "_2o-b";
export var stepIndicatorCircle = "_2o-6";
export var stepIndicatorCircleCompleted = "_2o-7";
export var stepIndicatorCircleDefault = "_2o-8";
export var stepIndicatorTextCompleted = "_2o-9";
export var stepIndicatorTextDefault = "_2o-a";
export var stepPending = "_2o-5";
export var wizardContainer = "_2o-1";
export var wizardContent = "_2o-2";
export var wizardModal = "_2o-0";